import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import iconSprite from '../../../assets/icon-sprite.svg';
import { updateBusiness } from '../../actions/account';

class OnboardBankAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  handleOnChange = (e) => this.setState({ [e.target.name]: e.target.value });

  handleSubmit = (e) => {
    const { onClose } = this.props;
    e.preventDefault();
    this.setState({ loading: 'Processing' }, async () => {
      try {
        const response = await updateBusiness(this.state);
        if (response.status !== 'success') throw new Error(response?.message);
        toast.success(response?.message);
        onClose?.();
      } catch (error) {
        this.setState({ loading: false },
          () => toast.error(error.response?.data?.message || error.response?.statusText
            || error.message
            || 'Seems like something went wrong with your request. Please try again.'));
      } finally {
        this.setState({ loading: false });
      }
    });
  }

  render() {
    const { visible, onClose = function $() {}, banks } = this.props;
    const { loading } = this.state;
    return (
      <Modal className="modal fade" centered show={visible} onHide={onClose}>
        <form action="" className="modal-form" onSubmit={this.handleSubmit}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="addDetailsLabel">Add business account details</h5>
              <button type="button" className="close" onClick={onClose}>
                <svg width="48" height="48">
                  <use xlinkHref={iconSprite + '#close-icon'}></use>
                </svg>
              </button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label htmlFor="account_number" className="form-label">Account Number</label>
                <input
                  type="number"
                  className="form-control"
                  id="account_number"
                  onChange={this.handleOnChange}
                  name="account_number" />
              </div>

              <div className="form-group">
                <div className="input-with-icon">
                  <select className="form-control" id="bank_code" name="bank_code" onChange={this.handleOnChange}>
                    <option>Bank Name</option>
                    {banks.map((bank) => (
                      <option
                        key={bank.id}
                        value={bank.additional_code}>
                        {bank.code_description}
                      </option>
                    ))}
                  </select>
                  <span className="input-icon">
                    <svg width="24" height="24">
                      <use xlinkHref={`${iconSprite}#dropdown`}></use>
                    </svg>
                  </span>
                </div>
              </div>

            </div>
            <div className="modal-footer">
              <button type="submit" className="btn btn-primary" disabled={!!loading}>{loading || 'Add'}</button>
            </div>
          </div>
        </form>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  banks: state.utils?.banks || [],
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OnboardBankAccount);
